import React from "react";
import clsx from "clsx";
import "./avatar.styles.scss";

export interface AvatarProps extends React.ImgHTMLAttributes<HTMLElement> {
	size: number;
	src: string;
	alt: string;
	className?: string;
}

const BlockName = "avatar";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {},
} as const;

export type AvatarComponent = React.FC<AvatarProps> & {
	ClassNames: typeof ClassNames;
};

export const Avatar = ((props: AvatarProps) => {
	const { size, src, alt, className, ...restProps } = props;
	return (
		<div title={alt} className={clsx(Avatar.ClassNames.Block, className)} {...restProps}>
			<img
				draggable={false}
				src={src}
				alt={alt}
				style={{ width: `${size}px`, height: `${size}px` }}
			/>
		</div>
	);
}) as AvatarComponent;

Avatar.ClassNames = ClassNames;
